<template>
  <v-card color="white" flat tile>
    <v-toolbar height="90px">
      <div class="container">
        <div class="nav-bar py-10">
          <div class="logo">
            <v-img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTxNMzSnYOp-z9_xVG_Tf5LWc5NZinIWZLccxNrWkEQibVFjjQW&usqp=CAU"
            ></v-img>
          </div>

          <!-- <v-toolbar-title>NERDOF</v-toolbar-title> -->
          <div class="ml-auto py-3 hidden-xs">
            <a class="mx-4 subtitle-1" @click="openContact">
              <span style="color:black">Contact</span>
            </a>

            <a class="mx-4 subtitle-1" @click="openLogin">
              <span style="color:black">Log In</span>
            </a>

            <a class="mx-4 subtitle-1" @click="openSignUp">
              <span style="color:black">Sign Up</span>
            </a>
          </div>
        </div>
      </div>
    </v-toolbar>
    <v-divider></v-divider>
    <!-- <div class="container pb-0 px-0"> -->
    <div class="live-view">
      <div class="event-cover-box">
        <div class="poster-cover-box">
          <div class="bg-blur-cover"></div>
        </div>
        <div class="even-informtion-panel">
          <div class="container">
            <v-row>
              <v-col cols="12">
                <div class="flex-container">
                  <div class="event-cover">
                    <div class="poster-wrapper">
                      <div class="poster-with-skeleton">
                        <a href="#">
                          <v-img
                            height="520"
                            src="https://p-u.popcdn.net/event_details/posters/000/008/507/large/f546f6fef02edd143e3ad8ffc5b9575bc7bcc96d.png?1584977498"
                          ></v-img>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="event-information align-items-center flex-container hidden-xs">
                    <div class="information">
                      <small>Education</small>
                      <p class="display-1">1-Day Design Sprint Workshop #6</p>
                      <p class="title white--text">
                        <v-icon color="white">mdi-calendar-month</v-icon>22 Aug 2020 at 09:00 - 17:00
                      </p>
                      <p class="title white--text">
                        <v-icon color="white">mdi-account-multiple</v-icon>5 follow
                      </p>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>

      <div class="event-conrtet pt-10">
        <div class="container">
          <h3>What is Lorem Ipsum?</h3>
          <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
          <br />
          <h3>Where does it come from?</h3>
          <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.</p>
        </div>
      </div>
      <v-divider></v-divider>
      <div class="event-footer mt-5">
        <div class="container">
          <v-row>
            <v-col lg="6" md="6" cols="12">
              <div class="default-accepted-payments">
                <div class="accepted-payments mb-md-5">
                  <p>Accepted payments</p>
                  <img
                    height="22"
                    class="mr-3"
                    src="https://p-a.popcdn.net/assets/payments/visa-icon-6ef66dac3b67f1088fd40eef78e0c751133e3034b08033ceb110fcc6c2144b3f.png"
                    alt="Visa icon"
                  />
                  <img
                    height="22"
                    class="mr-3"
                    src="https://p-a.popcdn.net/assets/payments/master-icon-836783e92477aa37f06d320daec3807969603e72dddb699fd744e58686c48c31.png"
                    alt="Master icon"
                  />
                  <img
                    height="22"
                    class="mr-3"
                    src="https://p-a.popcdn.net/assets/payments/jcb-icon-40de1b4193e8ea8755c144d349b57be189ebc1c8337ef47acb2cb74eaf630182.png"
                    alt="Jcb icon"
                  />
                </div>
                <!-- .mb-4 -->
              </div>
            </v-col>
            <v-col lg="6" md="6" cols="12">
              <div class="payment-button">
                <v-btn class="my-5" tile dark color="#f48fb1">
                  <v-icon class="mr-3" color="white" left>mdi-credit-card-scan</v-icon>Payment
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <div class="footer-xs d-block d-sm-none">
      <ul class="item-list">
        <li class="item">
          <v-btn tile icon @click="openContact">
            <v-icon color="#f48fb1">mdi-email</v-icon>
          </v-btn>
        </li>
        <li class="item">
          <v-btn tile icon @click="openLogin">
            <v-icon color="#f48fb1">mdi-login</v-icon>
          </v-btn>
        </li>
        <li class="item">
          <v-btn tile icon @click="openSignUp">
            <v-icon color="#f48fb1">mdi-account-plus</v-icon>
          </v-btn>
        </li>
      </ul>
    </div>
    <v-dialog v-model="dialogLogin" max-width="600px">
      <v-card>
        <!-- <v-btn icon color="pink lighten-3" @click="dialogLogin = false" style="float: right;">
          <v-icon>mdi-close</v-icon>
        </v-btn>-->

        <v-card-title class="headline font-weight-bold">
          Log In
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1 darken-1 pr-0" icon @click="dialogLogin = false">
            <v-icon class="pa-0" size="20px">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="formLogin" v-model="validLogin">
              <warnningComponent
                v-bind:textInfo.sync="textWarning"
                v-bind:typestatus.sync="typeWarning"
                v-bind:alert.sync="showWarnnig"
              ></warnningComponent>
              <v-row>
                <v-col class="py-0" cols="12" sm="12" md="12">
                  <p class="mb-0 size">
                    *
                    <strong class="font-weight-bold">Email or Username</strong>
                  </p>
                  <v-text-field
                    v-model="emailLogin"
                    outlined
                    dense
                    :rules="userNameRules"
                    placeholder="Enter email or username"
                    required
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" sm="12" md="12">
                  <p class="mb-0 size">
                    *
                    <strong class="font-weight-bold">Password</strong>
                  </p>
                  <v-text-field
                    outlined
                    dense
                    placeholder="Enter password"
                    required
                    v-model="passwordLogin"
                    :rules="passwordRules"
                    :type="showPassword ? 'text' : 'password'"
                    :append-icon="!showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
            <v-row>
              <v-col cols="12">
                <v-btn
                  block
                  tile
                  color="pink pink lighten-3"
                  class="size"
                  dark
                  @click="login"
                >Log In</v-btn>

                <p class="mt-5 size font-weight-light">
                  Don’t have an account?
                  <a @click="switchToSignUp">
                    <span
                      style="color: #f48fb1!important;"
                      class="subtitle-1 font-weight-bold"
                    >Sign Up</span>
                  </a>
                </p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSignup" max-width="600px">
      <v-card>
        <!-- <v-btn icon color="pink lighten-3" @click="dialogSignup = false" style="float: right;">
          <v-icon>mdi-close</v-icon>
        </v-btn>-->

        <v-card-title class="headline font-weight-bold">
          Sign Up
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1 darken-1 pr-0" icon @click="dialogSignup = false">
            <v-icon class="pa-0" size="20px">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <warnningComponent
              v-bind:textInfo.sync="textWarning"
              v-bind:typestatus.sync="typeWarning"
              v-bind:alert.sync="showWarnnig"
            ></warnningComponent>
            <v-form ref="formRegister" v-model="validRegister">
              <v-row>
                <v-col class="py-0" cols="12" sm="12" md="12">
                  <p class="mb-0 size">
                    *
                    <strong class="font-weight-bold">Gender</strong>
                  </p>
                  <v-autocomplete
                    v-model="selectedGenderRegister"
                    :items="genders"
                    placeholder="Choose gender"
                    item-value="value"
                    item-text="text"
                    dense
                    outlined
                  ></v-autocomplete>
                </v-col>
                <v-col class="py-0" cols="12" sm="12" md="6">
                  <p class="mb-0 size">
                    *
                    <strong class="font-weight-bold">First Name</strong>
                  </p>
                  <v-text-field
                    v-model="firstNameRegister"
                    outlined
                    dense
                    placeholder="Enater first name"
                    :rules="firstNameRules"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" sm="12" md="6">
                  <p class="mb-0 size">
                    *
                    <strong class="font-weight-bold">Last Name</strong>
                  </p>
                  <v-text-field
                    v-model="lastNameRegister"
                    outlined
                    dense
                    placeholder="Enater last name"
                    :rules="lastNameRules"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" sm="12" md="12">
                  <p class="mb-0 size">
                    *
                    <strong class="font-weight-bold">Email</strong>
                  </p>
                  <v-text-field
                    v-model="emailRegister"
                    outlined
                    dense
                    placeholder="Enater email"
                    :rules="emailRules"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" sm="12" md="12">
                  <p class="mb-0 size">
                    *
                    <strong class="font-weight-bold">Username</strong>
                  </p>
                  <v-text-field
                    v-model="usernameRegister"
                    outlined
                    dense
                    placeholder="Enater username"
                    :rules="userNameRules"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" sm="12" md="6">
                  <p class="mb-0 size">
                    *
                    <strong class="font-weight-bold">Password</strong>
                  </p>
                  <v-text-field
                    v-model="passwordRegister"
                    outlined
                    dense
                    placeholder="Enter password"
                    :rules="passwordRules"
                    :type="showPasswordRegister ? 'text' : 'password'"
                    :append-icon="!showPasswordRegister ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPasswordRegister = !showPasswordRegister"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" sm="12" md="6">
                  <p class="mb-0 size">
                    *
                    <strong class="font-weight-bold">Confirm Password</strong>
                  </p>
                  <v-text-field
                    outlined
                    dense
                    placeholder="Enter password"
                    :rules="conFirmPasswordRules"
                    v-model="confirmPasswordRegister"
                    :type="showComfirmPassword ? 'text' : 'password'"
                    :append-icon="!showComfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showComfirmPassword = !showComfirmPassword"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
            <v-row>
              <v-col cols="12">
                <v-btn block tile color="pink lighten-3" class="size" @click="register" dark>Sign Up</v-btn>
                <p class="mt-5 size font-weight-light">
                  Have an account?
                  <a @click="switchToLogIn">
                    <span
                      style="color: #f48fb1!important;"
                      class="subtitle-1 font-weight-bold"
                    >Log In</span>
                  </a>
                </p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="contactDialog" max-width="800px">
      <v-card>
        <v-card-title class="headline font-weight-blod">
          Contact Us
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1 darken-1 pr-0" icon @click="contactDialog = false">
            <v-icon class="pa-0" size="20px">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-row class="ma-0 px-6 pb-5">
          <v-col cols="12">
            <v-row class="setStyleColContent">
              <v-col class="py-12" cols="12" xl="4" lg="4" md="4" sm="12">
                <v-row justify="space-around" class="ma-0">
                  <v-avatar size="150px">
                    <img src="@/assets/culi/logo-company.png" />
                  </v-avatar>
                </v-row>
                <div
                  class="organizeTitle title font-weight-bold"
                >Chulalongkorn University Language Institute</div>
              </v-col>

              <v-divider vertical></v-divider>
              <v-divider class="showDivider"></v-divider>

              <v-col cols="12" xl="7" lg="7" md="7" sm="12" class="pa-6">
                <div>
                  <span class="subtitle-1 font-weight-medium grey--text text--lighten-1">Tel</span>
                </div>
                <div>
                  <span class="title font-weight-bold">+662 218 6012</span>
                </div>
                <br />
                <div>
                  <span class="subtitle-1 font-weight-medium grey--text text--lighten-1">Address</span>
                </div>
                <div>
                  <span
                    class="title font-weight-bold"
                  >Prem Purachatra Building, Phayathai Road, Pathumwan, Bangkok 10330</span>
                </div>
                <br />
                <div>
                  <span class="subtitle-1 font-weight-medium grey--text text--lighten-1">Facebook</span>
                </div>
                <div>
                  <span class="title font-weight-bold">www.facebook.com/CULIChula</span>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import { register } from "@/service/account/register";
import warnningComponent from "../../components/warningAlert.vue";
import { checkCompany, login, getInfo } from "@/service/account/login";
import { checkDevice } from "@/helper/checkDevice";
export default {
  components: {
    warnningComponent
  },
  data() {
    return {
      contactDialog: false,
      validLogin: false,
      validRegister: false,
      dialogLogin: false,
      dialogSignup: false,
      showPassword: false,
      showPasswordRegister: false,
      showComfirmPassword: false,

      textWarning: "",
      typeWarning: "",
      showWarnnig: false,

      companyRegister: "5e6eebebe8d8c4414428ea74", //"5ebbb5bce2612059ead85d79",
      groupRegister: "5ed5f364a46cdf022fcc75f1", //"5ed5d775a46cdf022fcc75f0",

      firstNameRegister: "",
      lastNameRegister: "",
      selectedGenderRegister: "male",
      emailRegister: "",
      usernameRegister: "",
      passwordRegister: "",
      confirmPasswordRegister: "",

      emailLogin: "", //"support@nerdof.com"
      passwordLogin: "", //"support1234"

      genders: [
        {
          text: "Male",
          value: "male"
        },
        {
          text: "Female",
          value: "female"
        },
        {
          text: "Unknown",
          value: null
        }
      ],
      // genderRules: [v => !!v || "Please choose your gender"],
      firstNameRules: [v => !!v || "Please enter your first name"],
      lastNameRules: [v => !!v || "Please enter your last name"],
      userNameRules: [v => !!v || "Please enter your username"],
      passwordRules: [
        v => !!v || "Please enter password",
        v => v.length >= 8 || "Please enter a password of at least 8 characters"
      ],
      conFirmPasswordRules: [
        v =>
          v.length >= 8 || "Please enter a password of at least 8 characters",
        v =>
          (!!v && v === this.passwordRegister) ||
          "Please enter the matched password"
      ],

      emailRules: [
        v => !!v || "Please enter your email",
        v => /.+@.+\..+/.test(v) || "Please enter type email"
      ]
    };
  },
  methods: {
    openContact() {
      this.contactDialog = true;
    },
    openLogin() {
      this.dialogLogin = true;
      this.$refs.formLogin.resetValidation();

      this.emailLogin = "";
      this.passwordLogin = "";
      this.showPassword = false;

      this.textWarning = "";
      this.typeWarning = "";
      this.showWarnnig = false;
    },
    openSignUp() {
      this.dialogSignup = true;
      this.$refs.formRegister.resetValidation();

      this.firstNameRegister = "";
      this.lastNameRegister = "";
      (this.selectedGenderRegister = "male"), (this.emailRegister = "");
      this.usernameRegister = "";
      this.passwordRegister = "";
      this.confirmPasswordRegister = "";

      this.textWarning = "";
      this.typeWarning = "";
      this.showWarnnig = false;
    },
    switchToSignUp() {
      this.dialogLogin = false;
      this.openSignUp();
    },
    switchToLogIn() {
      this.dialogSignup = false;
      this.openLogin();
    },
    async login() {
      if (this.$refs.formLogin.validate()) {
        let checkCompanyResult = await checkCompany({
          username: this.emailLogin
        });

        if (checkCompanyResult) {
          checkCompanyResult.forEach(async company => {
            if (company.companies[0]._id == this.companyRegister) {
              let device = checkDevice();
              let result = await login({
                id: company._id,
                password: this.passwordLogin,
                platform: device.platform,
                osversion: device.osversion,
                device: device.device
              });

              if (result.data.status == false) {
                this.warnnig(
                  "The email or username that you've entered doesn't match any account",
                  "warning"
                );
                return;
              } else {
                await localStorage.setItem(
                  "x-session-token",
                  result.data.result.token
                );
                await localStorage.setItem(
                  "expWeb",
                  result.data.result.endTime
                );

                let resultInfo = await getInfo();
                await this.$store.commit("setTheme", resultInfo.info);
                await this.$router.push({ path: "/" });
              }
            }
          });
        } else {
          this.warnnig(
            "The email or username that you've entered doesn't match any account",
            "warning"
          );
        }
      } else {
        this.warnnig("Something wrong", "warning");
      }
    },
    async register() {
      if (this.$refs.formRegister.validate()) {
        let result = await register({
          username: this.usernameRegister,
          password: this.passwordRegister,
          firstName: this.firstNameRegister,
          lastName: this.lastNameRegister,
          image: null,
          studentCode: "",
          gender: this.selectedGenderRegister,
          email: this.emailRegister,
          identificationNumber: "",
          companies: [this.companyRegister],
          user_groups: [this.groupRegister]
        });

        console.log(result);

        if (result.message == "username or email duplicade") {
          this.warnnig("Username or Email is duplicaded", "warning");
        } else if (result.code == 403) {
          this.warnnig("Something wrong", "warning");
        } else {
          this.dialogSignup = false;
        }
      } else {
        this.warnnig("Something wrong", "warning");
      }
    },
    warnnig(text, type) {
      this.textWarning = text;
      this.typeWarning = type;
      this.showWarnnig = true;
    }
  }
};
</script>
<style scoped lang="scss">
.live-view {
  background: #fff;
  @media only screen and (max-width: 767px) {
    padding-top: 13px;
  }
}
.size {
  font-size: 16px;
}
.v-application .primary--text {
  color: #f48fb1 !important;
  caret-color: #f48fb1 !important;
}
.v-text-field .v-input__control,
.v-text-field .v-input__slot,
.v-text-field fieldset {
  border-radius: unset;
}
.v-application .primary--text {
  color: #e5e5e6;
  caret-color: #e5e5e6;
}
.v-text-field--outlined {
  border-radius: 1px;
  color: #e5e5e6;
}
.event-cover-box {
  //   margin-top: -101px;
  //   padding-top: 101px;
  margin-top: -20px;
  padding-top: 7px;
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  background: rgba(255, 255, 255, 0.3);
}
.poster-cover-box {
  overflow: hidden;
  z-index: -1;
}
.bg-blur-cover {
  // background-image: url("../../assets/bg-live.png");
  background-image: url("https://p-u.popcdn.net/event_details/posters/000/008/507/large/f546f6fef02edd143e3ad8ffc5b9575bc7bcc96d.png?1584977498");

  filter: blur(20px);

  -webkit-filter: blur(20px);
  height: 580px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  z-index: -1;
}
.spacer-sm {
  display: block;
  height: 24px;
}
.spacer {
  display: block;
  height: 48px;
}
.flex-container {
  display: flex;
  flex-flow: row wrap;
  @media only screen and (max-width: 767px) {
    display: block;
  }
}
.event-cover {
  max-width: 32%;
  @media only screen and (max-width: 767px) {
    width: 100%;
    max-width: 100%;
  }
}
.poster-wrapper {
  background-color: rgba(0, 1, 6, 0.8);
  color: rgb(255, 255, 255);
}
.poster-with-skeleton {
  max-width: 100%;
  //   padding-bottom: 141.5%;
  position: relative;
  width: 800px;
}
.event-information {
  // background-color: rgba(5, 195, 202, 0.8);
  background-color: rgba(85, 85, 85, 0.9);
  color: rgb(255, 255, 255);
  width: 68%;
  position: relative;
  .information {
    position: absolute;
    top: 50%;
    left: 10%;
    transform: translate(0, -50%);
  }
}
.even-informtion-panel {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  padding-top: 7px;
}

* {
  box-sizing: border-box;
}

.organizeTitle {
  text-align: center;
}
.setStyleColContent {
  border: 0.5px solid #e5e5e6;
}
.setStyleColLogo {
  border-left: 0.5px solid #e5e5e6;
  border-top: 0.5px solid #e5e5e6;
  border-bottom: 0.5px solid #e5e5e6;
  border-right: 0.5px solid #e5e5e6;
}
//bar
.nav-bar {
  display: flex;
  @media only screen and (max-width: 767px) {
    margin: 0 auto;
  }
  .logo {
    width: 260px;
    @media only screen and (max-width: 767px) {
      margin: 0 auto;
    }
  }
}
.footer-xs {
  background: #fff;
}
.item-list {
  display: flex;
  widows: 100%;
  padding: 10px 0;
  position: fixed;
  bottom: 0;
  width: 100%;
  box-shadow: -1px -1px 1px 0px #dcdcdc52;
  background: #fff;

  .item {
    text-align: center;
    list-style: none;
    flex-grow: 1;
  }
}
.payment-button {
  text-align: right;
  @media only screen and (max-width: 767px) {
    text-align: center;
  }
}
.accepted-payments {
  text-align: left;
  @media only screen and (max-width: 767px) {
    text-align: center;
  }
}

@media only screen and (min-width: 961px) {
  .showDivider {
    display: none;
  }
}
@media only screen and (max-width: 767px) {
  .hidden-xs {
    display: none;
  }
  .xs-no-margin {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .xs-no-padding {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
@media (min-width: 1904px) {
  .container {
    max-width: 1185px !important;
  }
}
.event-footer {
  margin-bottom: 0px;
  @media only screen and (max-width: 767px) {
    margin-bottom: 60px;
  }
}
</style>